/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_RedoInputs */

const en_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo`)
};

const fr_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retablir`)
};

const de_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen`)
};

const it_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifare`)
};

const ru_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переделать`)
};

const es_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehacer`)
};

const zh_cn2_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重做`)
};

const ja_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やり直す`)
};

const hi_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर से करना`)
};

const pt_pt2_common_redo = /** @type {(inputs: Common_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refazer`)
};

/**
* | output |
* | --- |
* | "Redo" |
*
* @param {Common_RedoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_redo = /** @type {((inputs?: Common_RedoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_RedoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_common_redo(inputs)
	if (locale === "de") return de_common_redo(inputs)
	if (locale === "it") return it_common_redo(inputs)
	if (locale === "ru") return ru_common_redo(inputs)
	if (locale === "es") return es_common_redo(inputs)
	if (locale === "zh-CN") return zh_cn2_common_redo(inputs)
	if (locale === "ja") return ja_common_redo(inputs)
	if (locale === "hi") return hi_common_redo(inputs)
	if (locale === "pt-PT") return pt_pt2_common_redo(inputs)
	return en_common_redo(inputs)
});